export default {
    totalItems: state => state.totalItems,
    posts: state => state.posts,
    rowsPerPage: state => state.pagination.rowsPerPage,
    pagination: state => state.pagination
}
